export default {
  setUserFromAuth(state, payload) {
    state._id = payload._id;
    state.token = payload.token;
    state.name = payload.name;
  }
}